import { Divider } from 'antd';
import styled from 'styled-components';

const StyledDivider = styled(Divider)`
  margin: 14px 0px 14px 0px;
  width: 92%;
  min-width: 92%;
  border-color: #d9d9d9;
`;

export default StyledDivider;
